import React from 'react';
import ChrMetric from '../../../generic/PageUI/Compound/Metric/ChrMetric';
import { MetricUId } from '../../Metrics/constants';
import { getMetricDataFromArray } from '../../Metrics/utils';
import StackedBarChart from '../../Reports/templates/StackedBarChart';
import WidgetBodyWrapper from '../WidgetBodyWrapper';
import getChartConfig from './utils';

const Body = (props) => {
  const { metrics } = props;
  const allConnectedUsersOnetimeWithRoles = getMetricDataFromArray(metrics, MetricUId.ALL_CONNECTED_USERS_ONETIME_WITH_ROLES);
  const neverConnectedUsersOnetimeWithRoles = getMetricDataFromArray(metrics, MetricUId.NEVER_CONNECTED_USERS_ONETIME_WITH_ROLES);
  const dataAvailable = metrics.some(metric => metric.data.value > 0);
  const getOptionsForMarker = colorName => ({ show: dataAvailable, className: `cui-management-report-temp-chart-${colorName}` });

  return (
    <WidgetBodyWrapper { ...props } >
      <div className='d-flex flex-column'>
        { dataAvailable &&
          <StackedBarChart chartOptions={ getChartConfig({ metrics }) } />
        }
        <WidgetBodyWrapper { ...props } wrapperPadding={ `${dataAvailable ? "py-3" : ""} px-1` } >
          <ChrMetric { ...allConnectedUsersOnetimeWithRoles } marker={ getOptionsForMarker("blue") } />
          <ChrMetric { ...neverConnectedUsersOnetimeWithRoles } marker={ getOptionsForMarker("red") } />
        </WidgetBodyWrapper>
      </div>
    </WidgetBodyWrapper>
  );
};

export default Body;
